import HttpRequest from '@/utils/httpRequest';

export function list(query) {
    return HttpRequest({
        url: 'business/lessonperiod/list',
        method: 'post',
        data :query
    });
}

export function info(query) {
    return HttpRequest({
        url: 'business/lessonperiod/info/{id}',
        method: 'post',
        data :query
    });
}

export function save(query) {
    return HttpRequest({
        url: 'business/lessonperiod/save',
        method: 'post',
        data :query
    });
}

export function update(query) {
    return HttpRequest({
        url: 'business/lessonperiod/update',
        method: 'post',
        data :query
    });
}

export function deleteObj(id) {
    return HttpRequest({
        url: 'business/lessonperiod/delete',
        method: 'delete',
        params :{id}
    });
}


export function queryLessonPeriod(lessonId) {
    return HttpRequest({
        url: 'business/lessonperiod/list',
        method: 'post',
        params:{
            page:1,
            limit:9999999,
            lessonId
        }
    });
}